/**
@flow
@format
*/

import React from 'react';
import { ButtonPillGroup as KrispyButtonPillGroup } from '@krispy/buttons/web';
import type { Props as ButtonPillType } from './ButtonPill';

export type Props = $ReadOnly<{|
  /**
     * Pills array
     */
  pills: Array<{
    ...ButtonPillType,
    marginRight?: string,
    marginBottom?: string,
    marginTop?: string,
  }>,
  /**
     * Width of group
    */
  width?: string,
  /**
     * Margin-bottom of the group
    */
  marginBottom?: string,
  /**
     * Stack pills vertically
     */
  stacked?: boolean,
|}>;

const ButtonPillGroup = (props: Props): React$Node => {
  const {
    ...rest
  } = props;

  return (
    <KrispyButtonPillGroup
      {...rest}
    />
  );
};

export default ButtonPillGroup;
